import React from 'react'
import styled from 'styled-components'

import { GetCustomerCartQuery } from '../../../graphql/magento'
import { totalQuantityExcludingDependents } from '../../../lib/cart/item'
import MobileCartIcon from '../../global/header/MobileCartIcon'
import ScreenReaderOnly from '../../ScreenReaderOnly'

export interface OpenMiniCartProps {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  className?: string
  setOpenMiniCartModal: React.Dispatch<React.SetStateAction<boolean>>
}

const StyledMobileCartIcon = styled(MobileCartIcon)`
  color: ${({ theme }) => theme.colors.brand.red};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  width: 27px;
  height: 27px;
  .cart-icon-qty-text {
    transition: opacity 0.35s;
    opacity: ${({ quantityText }) => (quantityText ? 1 : 0)};
  }

  @media print {
    display: none;
  }
`

const OpenMiniCart: React.FC<OpenMiniCartProps> = ({ cart, className, setOpenMiniCartModal }) => {
  const totalQuantity = totalQuantityExcludingDependents(cart.items, cart.total_quantity)
  const cartQuantityText = totalQuantity ? `${totalQuantity < 100 ? totalQuantity : '99+'}` : ''

  return (
    <button className={className} onClick={() => setOpenMiniCartModal(true)} type="button">
      <StyledMobileCartIcon quantityText={cartQuantityText} />
      <ScreenReaderOnly>Open cart</ScreenReaderOnly>
    </button>
  )
}

const StyledOpenMiniCart = styled(OpenMiniCart)`
  // override user-agent styles
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  // slightly larger touchpoint
  padding: 15px;
  overflow: hidden;
`

export default StyledOpenMiniCart
